'use strict';
var CookieBanner;

CookieBanner = (function() {
  function CookieBanner(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$body = $('#ls-body');
    this.initialize();
  }

  CookieBanner.prototype.initialize = function() {
    this.delay = 300;
    if (!Cookie.get('acknowledge_cookies')) {
      this.$body.addClass('ls-visible-cookieBanner');
      this.$el.fadeIn(this.delay);
      return this.attachHideListener();
    }
  };

  CookieBanner.prototype.attachHideListener = function() {
    var acknowledgeLink;
    acknowledgeLink = this.$el.find('#ls-accept-cookies');
    return acknowledgeLink.one('click.cookie-banner-action', (function(_this) {
      return function(e) {
        e.preventDefault();
        Groupon.Utils.setSiteCookies({
          acknowledge_cookies: true
        });
        _this.$el.fadeOut(_this.delay).remove();
        return _this.$body.removeClass('ls-visible-cookieBanner');
      };
    })(this));
  };

  return CookieBanner;

})();

window.CookieBanner = CookieBanner;

